import { gql } from "@apollo/client";
import { PRIVATE_AUTH_ANNOTATION } from "shared/graphql/links/authBff.link";

export const USERS = gql`
  query Users(
    $where: UserWhereInput
    $isIn: JSONObject
    $exclude: [String]
    $custom: JSONObject
    $take: Int
    $skip: Int
    $like: UserWhereInput
  ) {
    users(
      where: $where
      take: $take
      skip: $skip
      like: $like
      isIn: $isIn
      custom: $custom
      exclude: $exclude
    ) {
      data {
        id
        firstname
        lastname
        gender
        phone
        type
        meta
        params
        email
        address
        zipCode
        city
        isActive
        organization {
          id
          telecoms {
            system
            value
          }
        }
        poles {
          id
        }
      }
      count
    }
  }
`;

export const USER = gql`
  query User($where: UserWhereInput) {
    user(where: $where) {
      id
      firstname
      lastname
      phone
      gender
      meta
      params
      email
      address
      zipCode
      city
      poles {
        id
      }
      organization {
        id
        broker {
          id
          orias
          socialReason
          code
          rcsNumber
        }
        telecoms {
          id
          system
          value
        }
      }
      skills {
        id
        type
        value
        groupIndex
      }
    }
  }
`;

export const CHECK_USER = gql`
  query Profile {
    profile {
      id
      hasSignedIn
      isActive
      firstname
      lastname
      email
      phone
      type
      meta
      params
      organization {
        name
        id
        icon
        config {
          envelop
          template
          useQuoteDownloadLinks
          emailConfig {
            disabled
            email
          }
          EFFICIAL_CLIENT_ID
          aircall {
            enabled
          }
          globalProjectsViewEnabled
          hotList {
            enabled
            sourceName
            signalFeed
          }
          hotListAvailable
          leadTypologyEnabled
        }
        telecoms {
          id
          system
          value
        }
        broker {
          id
          isInternal
          orias
          code
          rcsNumber
        }
      }
      poles {
        id
      }
      permissions {
        granted
        module
        submodules {
          name
          granted
          actions
        }
      }
    }
  }
`;

export const USER_AUTH = gql`
  query user($where: UserWhereInput) {
    user(where: $where) @${PRIVATE_AUTH_ANNOTATION} {
      id
    }
  }
`;

export const USER_INVITATION = gql`
  query UserInvitation($where: UserWhereInput!) {
    userInvitation(where: $where) {
      status
    }
  }
`;

const users = { USERS, USER, CHECK_USER, USER_AUTH, USER_INVITATION };

export default users;

export const USER_LOCK_STATES = gql`
  query UserLockStates($where: UserWhereInput, $isIn: JSONObject) {
    userLockStates(where: $where, isIn: $isIn) {
      id
      locked
    }
  }
`;
